import { atom } from 'jotai';

import { PayplePaymentsResult } from '@/types/payple';

export const payplePayResultAtom = atom<PayplePaymentsResult | null>(null);

export const isJQueryScriptLoadedAtom = atom(false);
export const isPaypleScriptLoadedAtom = atom(false);
